// @flow
import React, { Component } from 'react'
import { StyledContent } from '../../styles/mixins'
import { Card } from 'reactstrap'
import { connect } from 'react-redux'
import '@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css'
import {
  PagingState,
  CustomPaging,
  SortingState,
  IntegratedSorting
} from '@devexpress/dx-react-grid'
import {
  Grid,
  Table,
  TableHeaderRow,
  PagingPanel
} from '@devexpress/dx-react-grid-bootstrap4'
import { getOrdersHistoryList } from '../../actions/orders'

type Props = {
  getOrdersHistory: void => void,
  ordersHistory: Object[]
}

type State = {
  columns: Object[],
  rows: Object[],
  totalCount: number,
  pageSize: number,
  pageSizes: number[],
  currentPage: number,
  tableColumnExtensions: Object[]
}

class OrdersView extends Component<Props, State> {

  state: State = {
    columns: [
      { name: 'OrderNumber', title: 'Order #' },
      { name: 'OrderDate', title: 'Order Date' },
      { name: 'StoreCity', title: 'Store City' },
      { name: 'StoreState', title: 'Store State' },
      { name: 'Employee', title: 'Employee' },
      { name: 'SaleAmount', title: 'Sale Amount' }
    ],
    rows: [],
    totalCount: 0,
    pageSize: 10,
    pageSizes: [5, 10, 15],
    currentPage: 0,
    tableColumnExtensions: []
  }

  componentWillMount() {

    this.props.getOrdersHistory()
  }

  componentWillReceiveProps(nextProps) {

    if(nextProps.ordersHistory.length) {

      this.setState({
        totalCount: nextProps.ordersHistory.length
      }, () => {
        this.pagination(nextProps)
      })
    }
  }

  changeCurrentPage = (currentPage: number) => this.setState({ currentPage }, () => this.pagination(this.props))

  changePageSize = (pageSize: number) => this.setState({ pageSize }, () => this.pagination(this.props))

  pagination = (props: Object) => {

    const { ordersHistory } = props || this.props
    const { currentPage, pageSize } = this.state
    const rows = ordersHistory.slice(currentPage*pageSize, currentPage*pageSize + pageSize)
    
    this.setState({ rows })
  }

  render() {
    const {
      columns,
      tableColumnExtensions,
      pageSize,
      pageSizes,
      currentPage,
      totalCount,
      rows
    } = this.state

    return (
      <StyledContent>
        <Card>
          <Grid
            rows={rows}
            columns={columns}>

            <SortingState/>
            <IntegratedSorting />
            
            <PagingState
              currentPage={currentPage}
              onCurrentPageChange={this.changeCurrentPage}
              pageSize={pageSize}
              onPageSizeChange={this.changePageSize} />

            <CustomPaging totalCount={totalCount} />
            <Table columnExtensions={tableColumnExtensions} size="small" />
            <TableHeaderRow showSortingControls />
            <PagingPanel pageSizes={pageSizes} />

          </Grid>
        </Card>
      </StyledContent>
    )
  }
}

const mapStateToProps = (state: Object) => ({
  ordersHistory: state.orders.ordersHistory
})

const mapDispatchToProps = (dispatch: Function) => ({
  getOrdersHistory: () => {
    getOrdersHistoryList(dispatch)
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(OrdersView)


// WEBPACK FOOTER //
// ./src/components/view-orders/index.js